import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';
import { Receipt } from 'src/app/shared/models/receipt.model';

@Injectable({
  providedIn: 'root',
})
export class PaymentService {
  constructor(private httpClient: HttpClient) {}

  getReceiptDetail<T>(transactionId: string): Observable<T> {
    return this.httpClient.get<T>(
      `${environment.paymentAPIRoot}/api/receipt/getreceiptdetail?transactionId=${transactionId}`
    );
  }

  sendReceipt(payload: Receipt, fromTransaction = false): Observable<string> {
    return this.httpClient.post(
      `${environment.paymentAPIRoot}/api/Receipt/sendreceipt?fromTransaction=${fromTransaction}`,
      payload,
      {
        responseType: 'text',
      }
    );
  }
}
